const JobOrderStatus = {
  NotStarted: "Not Started",
  JobStarted: "Job Started",
  WSI: "WSI",
  EvaluationInProgress: "Evaluation in Progress",
  RepairInProgress: "Repair in Progress",
  InProgress: "In Progress",
  // ReleaseToSignatory: 'Released to Signatory',
  Completed: "Completed",
  PendingARCGeneration: "Pending ARC Generation",
  PendingCustomerApproval: "Pending Customer Approval",
  PendingCSDQuotation: "Pending CSD Quotation",
  PendingSubcon: "Pending Subcon",
  PendingAdmin: "Pending Admin",
  PendingMaterial: "Pending Material",
};

const jobOrderStatusMap = {
  not_started: {
    id: 14,
    name: JobOrderStatus.NotStarted,
  },
  wsi: {
    id: 7,
    name: JobOrderStatus.WSI,
  },
  in_progress: {
    id: 12,
    name: JobOrderStatus.InProgress,
  },
  repair_in_progress: {
    id: 1,
    name: JobOrderStatus.RepairInProgress,
  },
  evaluation_in_progress: {
    id: 6,
    name: JobOrderStatus.EvaluationInProgress,
  },
  pending_arc_generation: {
    id: 2,
    name: JobOrderStatus.PendingARCGeneration,
  },
  completed: {
    id: 10,
    name: JobOrderStatus.Completed,
  },
  pending_customer_approval: {
    id: 4,
    name: JobOrderStatus.PendingCustomerApproval,
  },
  pending_csd_quotation: {
    id: 5,
    name: JobOrderStatus.PendingCSDQuotation,
  },
  pending_subcon: {
    id: 9,
    name: JobOrderStatus.PendingSubcon,
  },
  pending_material: {
    id: 3,
    name: JobOrderStatus.PendingMaterial,
  },
};

const ViewPps = {
  overview: {
    id: 1,
    label: "Status Overview",
  },
  list: {
    id: 2,
    label: "List",
  },
  calendar: {
    id: 3,
    label: "Calendar",
  },
  gantt: {
    id: 4,
    label: "Gantt",
  },
  kanban: {
    id: 5,
    label: "Kanban",
  },
  planner: {
    id: 6,
    label: "Planner",
  },
};

const initialKanbanColumns = [
  {
    id: "notStarted",
    statusId: 8,
    title: JobOrderStatus.NotStarted,
    color: "text-gray-500",
    tasks: [],
  },
  {
    id: "wsi",
    statusId: 7,
    title: JobOrderStatus.WSI,
    color: "text-pink-500",
    tasks: [],
  },
  {
    id: "inProgress",
    statusId: 12,
    title: JobOrderStatus.InProgress,
    color: "text-blue-500",
    tasks: [],
  },
  {
    id: "repairinProgress",
    statusId: 1,
    title: JobOrderStatus.RepairInProgress,
    color: "text-indigo-500",
    tasks: [],
  },
  {
    id: "evaluationinProgress",
    statusId: 6,
    title: JobOrderStatus.EvaluationInProgress,
    color: "text-green-600",
    tasks: [],
  },
  {
    id: "pendingARCGeneration",
    statusId: 2,
    title: JobOrderStatus.PendingARCGeneration,
    color: "text-yellow-500",
    tasks: [],
  },
  // {
  //   id: 'releaseToSignatory',
  //   statusId: 2,
  //   title: JobOrderStatus.ReleaseToSignatory,
  //   color: 'text-orange-500',
  //   tasks: [],
  // },
  // {
  //   id: 'pendingArcGeneration',
  //   statusId: 2,
  //   title: JobOrderStatus.PendingARCGeneration,
  //   color: 'text-purple-500',
  //   tasks: [],
  // },
  {
    id: "completed",
    statusId: 1,
    title: JobOrderStatus.Completed,
    color: "text-green-700",
    tasks: [],
  },
  {
    id: "pendingCustomerApproval",
    statusId: 4,
    title: JobOrderStatus.PendingCustomerApproval,
    color: "text-red-500",
    tasks: [],
  },
  {
    id: "pendingCSDQuotation",
    statusId: 5,
    title: JobOrderStatus.PendingCSDQuotation,
    color: "text-cyan-600",
    tasks: [],
  },
  {
    id: "pendingSubcon",
    statusId: 9,
    title: JobOrderStatus.PendingSubcon,
    color: "text-teal-600",
    tasks: [],
  },
  {
    id: "pendingMaterial",
    statusId: 3,
    title: JobOrderStatus.PendingMaterial,
    color: "text-amber-600",
    tasks: [],
  },
];

const initialKanbanTechniciansColumn = [
  {
    id: "not-assigned",
    title: "Not Assigned",
    count: 0,
    color: "text-gray-400",
    tasks: [],
  },
];

const initialPieChart = [
  {
    id: "notStarted",
    title: JobOrderStatus.NotStarted,
    tasks: 0,
    fill: "var(--color-notStarted)",
  },
  {
    id: "wsi",
    title: JobOrderStatus.WSI,
    tasks: 0,
    fill: "var(--color-wsi)",
  },
  {
    id: "inProgress",
    title: JobOrderStatus.InProgress,
    tasks: 0,
    fill: "var(--color-inProgress)",
  },
  {
    id: "repairInProgress",
    title: JobOrderStatus.RepairInProgress,
    tasks: 0,
    fill: "var(--color-repairInProgress)",
  },
  {
    id: "evaluationInProgress",
    title: JobOrderStatus.EvaluationInProgress,
    tasks: 0,
    fill: "var(--color-releaseToSignatory)",
  },
  {
    id: "pendingARCGeneration",
    title: JobOrderStatus.PendingARCGeneration,
    tasks: 0,
    fill: "var(--color-pendingArcGeneration)",
  },
  {
    id: "completed",
    title: JobOrderStatus.Completed,
    tasks: 0,
    fill: "var(--color-completed)",
  },
  {
    id: "pendingCustomerApproval",
    title: JobOrderStatus.PendingCustomerApproval,
    tasks: 0,
    fill: "var(--color-pendingCustomerApproval)",
  },
  {
    id: "pendingCSDQuotation",
    title: JobOrderStatus.PendingCSDQuotation,
    tasks: 0,
    fill: "var(--color-pendingCSDQuotation)",
  },
  {
    id: "pendingSubcon",
    title: JobOrderStatus.PendingSubcon,
    tasks: 0,
    fill: "var(--color-pendingSubcon)",
  },
  {
    id: "pendingMaterial",
    title: JobOrderStatus.PendingMaterial,
    tasks: 0,
    fill: "var(--color-pendingMaterial)",
  },
  // { id: 'hardCopy', title: JobOrderStatus.HardCopy, tasks: 0, fill: 'var(--color-hardCopy)' },
];
const initialPieChartPriority = [
  { priority: 1, tasks: 0, fill: "var(--color-Critical)", name: "Critical" },
  { priority: 2, tasks: 0, fill: "var(--color-High)", name: "High" },
  { priority: 3, tasks: 0, fill: "var(--color-Medium)", name: "Medium" },
  { priority: 4, tasks: 0, fill: "var(--color-Low)", name: "Low" },
  { priority: 5, tasks: 0, fill: "var(--color-Minor)", name: "Minor" },
];
const initialStackBarChart = [
  { name: "machine", used: 0, unused: 0 },
  { name: "tools", used: 0, unused: 0 },
  { name: "technicians", used: 0, unused: 0 },
  { name: "consumable", used: 0, unused: 0 },
];
const initialStackBarChartTechnician = [
  {
    certificationIssuer: "FAA",
    certificationName: "Landing Gear Systems Certification",
    used: 0,
    unused: 0,
  },
  {
    certificationIssuer: "EASA",
    certificationName: "Aircraft Assembly Certification",
    used: 0,
    unused: 0,
  },
  {
    certificationIssuer: "ICAO",
    certificationName: "Drive Generator Systems Certification",
    used: 0,
    unused: 0,
  },
  {
    certificationIssuer: "FAA",
    certificationName: "Aircraft Electrical Systems Certification",
    used: 0,
    unused: 0,
  },
  {
    certificationIssuer: "EASA",
    certificationName: "General Aircraft Maintenance Certification",
    used: 0,
    unused: 0,
  },
];

const defaultSelectedItem = {
  id: null,
  workspaceId: 0,
  parentId: null,
  jobOrderNo: "",
  costCentre: "",
  shopId: null,
  statusId: null,
  processId: null,
  partId: null,
  customerId: null,
  dueDate: "",
  startDate: "",
  priority: null,
  standardHours: "",
  totalCost: "",
  totalSales: "",
  materialEdd: "",
  materialStatus: "",
  pbsubcontEdd: "",
  pbsubcontStatus: "",
  prodRemarks: "",
  workspace: {
    id: 0,
    workspaceName: "",
    workspaceCode: "",
    description: "",
    colorCode: "",
    icon: "",
    enableAI: false,
    configuration: "",
  },
  shop: "",
  process: null,
  status: {
    id: 0,
    workspaceId: 0,
    statusName: "",
    order: 0,
    colorCode: "",
    show: 0,
    workspace: "",
  },
  part: {
    id: 0,
    partNumber: "",
    partDescription: "",
    serialNumber: "",
    manufacturer: "",
    price: "",
  },
  customer: {
    id: 0,
    customerCode: "",
    customerName: "",
  },
  jobExtraValue: "",
  ppsTechnicians: [],
  subJobOrders: [],
};

export {
  initialKanbanColumns,
  initialKanbanTechniciansColumn,
  initialPieChart,
  initialPieChartPriority,
  initialStackBarChart,
  initialStackBarChartTechnician,
  defaultSelectedItem,
  JobOrderStatus,
  ViewPps,
  jobOrderStatusMap,
};
